import Div100vh from 'react-div-100vh';
import {
  colors,
  layers,
  opacity,
  spacing,
  transitions,
} from '@lamimed/pantheon';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

import { navigationWidth } from 'templates/patient-area/wrappers/MainWrapper/containers/Navigation/styles';

import { Props } from '.';

export const Container = styled(Div100vh)`
  width: 100%;
  max-width: ${navigationWidth};
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: -100%;
  background-color: ${colors.light};
  transition: right ${transitions.easeInAndOutBack};
  padding: ${spacing.small} ${spacing.medium};
`;

export const Backdrop = styled.div<Pick<Props, 'open'>>`
  ${({ open }) => css`
    background-color: ${rgba(colors.dark, opacity.hard)};
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    pointer-events: none;
    opacity: 0;
    visibility: hidden;
    z-index: ${layers.alert};
    transition: opacity 0.45s, visibility 0.45s ease;

    ${!!open &&
    css`
      opacity: 1;
      visibility: visible;
      pointer-events: initial;
      transition: opacity 0.45s, visibility 0.45s ease;

      ${Container} {
        right: 0;

        &::after {
          content: '';
          position: fixed;
          left: 0;
          bottom: 0;
          height: 100vh;
          background-color: ${colors.light};
        }
      }
    `}
  `}
`;
